import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { X, Sparkles } from "lucide-react";

const STORAGE_KEY = "hearinsight_announcement_dismissed";

export default function AnnouncementBar() {
  const [items, setItems] = useState([]);
  const [dismissed, setDismissed] = useState(() => {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]"); }
    catch { return []; }
  });
  useEffect(() => { 
    api.get("/marketing/announcements")
      .then(r => {
        if (Array.isArray(r.data)) setItems(r.data);
        else setItems([]);
      })
      .catch(() => setItems([])); 
  }, []);
  const visible = Array.isArray(items) ? items.filter(a => !dismissed.includes(a.id)) : [];
  if (visible.length === 0) return null;
  const a = visible[0];
  const close = () => {
    const next = [...dismissed, a.id];
    setDismissed(next);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  };
  return (
    <div className="bg-gradient-to-r from-[#6B4BA3] via-[#7E5FB5] to-[#9D84D2] text-white text-sm" data-testid="announcement-bar">
      <div className="lumina-container flex items-center justify-between gap-3 py-2.5">
        <div className="flex items-center gap-2 min-w-0">
          <Sparkles className="w-3.5 h-3.5 shrink-0" />
          <span className="truncate">{a.text}</span>
          {a.link && (
            <Link to={a.link} className="underline font-medium shrink-0 hover:opacity-80" data-testid="announcement-link">
              {a.link_text || "Lihat"} →
            </Link>
          )}
        </div>
        <button onClick={close} className="p-1 hover:bg-white/10 rounded-full shrink-0" data-testid="announcement-dismiss">
          <X className="w-3.5 h-3.5" />
        </button>
      </div>
    </div>
  );
}
